import * as React from "react";
export const DialogStateContext = React.createContext({ openedDialogs: [], open: () => {
}, close: () => {
} });
export const DialogStateProvider = ({ children }) => {
  const [openedDialogs, setOpenedDialogs] = React.useState([]);
  const open = (id) => {
    if (!openedDialogs.includes(id)) {
      setOpenedDialogs([...openedDialogs, id]);
    }
  };
  const close = (id) => {
    if (openedDialogs.includes(id)) {
      setOpenedDialogs(openedDialogs.filter((dialog) => dialog !== id));
    }
  };
  return /* @__PURE__ */ React.createElement(DialogStateContext.Provider, { value: { openedDialogs, open, close } }, children);
};
